import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../page/Login';
import Card from '../../../core/components/layout/card/Card';
import { t } from 'i18next';
import ChangePasswordForm from './change-password-form/ChangePasswordForm';
import CreateAccountForm from './create-account-form/CreateAccountForm';
import ResetPasswordForm from './reset-password-form/ResetPasswordForm';

export default function UnauthenticatedContent() {
    return (
        <Routes>
            <Route
                path='/login'
                element={<Login />} />
            <Route
                path='/create-account'
                element={
                    <Card>
                        <h2>{t("Sign Up")}</h2>
                        <CreateAccountForm />
                    </Card>
                }
            />
            <Route
                path='/reset-password'
                element={
                    <Card>
                        <h2>{t("Reset Password")}</h2>
                        <span>{t("Please enter the email address that you used to register, and we will send you a link to reset your password via Email.")} </span>
                        <ResetPasswordForm />
                    </Card>
                }
            />
            <Route
                path='/change-password/:recoveryCode'
                element={
                    <Card>
                        <h2>{t("Change Password")}</h2>
                        <ChangePasswordForm />
                    </Card>
                }
            />
            <Route path='*' element={<Navigate to={'/login'} />}></Route>
        </Routes>
    );
}
